import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiGet, apiPost } from '../services/api';

export interface QuarantineDocument {
  DokumentID: string;
  AvtaleID: string | null;
  Filnavn_original: string;
  Filtype: string;
  Filstoerrelse_kb: number;
  Lastet_opp_av: string;
  Lastet_opp_dato: string;
  Analyse_status: 'failed' | 'pending';
  Analyse_feilmelding: string | null;
  Analysert_tidspunkt: string | null;
  Ekstraksjon_status: string | null;
  AvtaleTittel: string | null;
}

export interface QuarantineFilters {
  page: number;
  pageSize: number;
  status: string;
  search: string;
  sortBy: string;
  sortDir: string;
}

export const defaultQuarantineFilters: QuarantineFilters = {
  page: 1,
  pageSize: 50,
  status: '',
  search: '',
  sortBy: 'Lastet_opp_dato',
  sortDir: 'DESC',
};

interface QuarantineListResponse {
  data: QuarantineDocument[];
  pagination: { page: number; pageSize: number; totalCount: number };
}

function buildQueryString(filters: QuarantineFilters): string {
  const params = new URLSearchParams();
  params.set('page', String(filters.page));
  params.set('pageSize', String(filters.pageSize));
  if (filters.status) params.set('status', filters.status);
  if (filters.search) params.set('search', filters.search);
  params.set('sortBy', filters.sortBy);
  params.set('sortDir', filters.sortDir);
  return params.toString();
}

export function useQuarantineList(filters: QuarantineFilters) {
  return useQuery({
    queryKey: ['quarantine', filters],
    queryFn: () => apiGet<QuarantineListResponse>(`/quarantine?${buildQueryString(filters)}`),
    placeholderData: (prev) => prev,
  });
}

export function useRetryDocument() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (docId: string) =>
      apiPost(`/quarantine/${docId}/retry`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['quarantine'] });
    },
  });
}

export function useRejectDocument() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (docId: string) =>
      apiPost(`/quarantine/${docId}/reject`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['quarantine'] });
    },
  });
}
